import api from "../../common/dependencies/utils/Api";
import {
  GET_A_MENTOR_FORM,
  LOGIN_DATA,
  REGISTER_COHORT,
  SAVE_DRAFT_COHORT
} from "../../common/constants/ApplicationUrl";

export const GetMentorFormServices = {
  getMentorFormServices() {
    return api
      .GET(`${GET_A_MENTOR_FORM}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  registerCohort(params) {
    //

    return api.POSTDATA(REGISTER_COHORT, params).then((response) => {
      //
      return response;
    });
  },
  savedraftCohort(params) {
    //

    return api.POSTDATA(SAVE_DRAFT_COHORT, params).then((response) => {
      //
      return response;
    });
  },
};
